//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Advancelist.js";
import { tolocalestringnumber } from "../computing/tolocalestringnumber";
import unity from "@/unity/unity";

export default {
  name: "advance-list",
  data(vm) {
    return {
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      search_status: "",
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      status: ["Draft", "Request", "Approve", "Reject"],
      datefrom: null,
      dateto: null,
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      mDataArray: [],
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      // mDataArray: [
      //   {
      //     no: 1,
      //     date: "1/11/2022",
      //     name: "testname",
      //     customer: "ABS co Ltd",
      //     amount: "10,000",
      //     status: "Unapproved",
      //   },
      //   {
      //     no: 2,
      //     date: "2/11/2022",
      //     name: "testname2",
      //     customer: "ABS co Ltd",
      //     amount: "3,000",
      //     status: "Approved",
      //   },
      // ],
      headers: [
        {
          text: " Job Title/Case ",
          value: "job_name",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "140px",
        },
        {
          text: "Client",
          value: "customer_name",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "150px",
        },
        {
          text: "Start Date",
          value: "checkInDate_show",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "150px",
          align: "center",
        },

        {
          text: "End Date",
          value: "checkOutDate_show",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "150px",
          align: "center",
        },
        {
          text: "Hour",
          value: "durationShow",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "140px",
          align: "end",
        },
        {
          text: "Charge Type",
          value: "chargeType",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "120px",
        },
        {
          text: "Prospect",
          value: "prospect",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "100px",
        },
        {
          text: "Detail",
          value: "detail",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "200px",
        },
        {
          text: "",
          value: "actions",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "110px",
          align: "center",
        },
      ],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      jobTitle_list: [],
      searchCharge: null,
      searchChargeJob: null,
      searchEmp: [],
      delete_id: 0,
      dialogDeleteActivity: false,
    };
  },

  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.initialize();
  },
  components: {
    SuccessDialog,
  },
  beforeUpdate() {},
  computed: {
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // console.log("res_auth:" + JSON.stringify(res_auth.data));
    // console.log("authorize_view:" + this.authorize_view);
    // console.log("authorize_add:" + this.authorize_add);
    // console.log("authorize_edit:" + this.authorize_edit);
    // console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);
    // await this.loadCompanyMaster(comp_id);
    // await this.loadDepartmentMaster(comp_id);
    // await this.loadPositionMaster(comp_id);

    await this.loadAuthorize();
    // await this.loaddata();

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

    this.$hideLoader();
  },
  methods: {
    // 1. เพิ่มฟังก์ชัน findAllByAPISearch
    async findAllByAPISearch() {
      await this.onSearchPagination();
    },

    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        const result = await api.getAllActivityByUserIDPaginationV2(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.USER_ID),
          this.search,
          this.searchCharge,
          this.searchChargeJob,
          this.datefrom,
          this.dateto
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.mDataArray2.forEach((item) => {
          var decimalHour = Number(item.duration);
          const hours = Math.floor(decimalHour); // ได้ 3 ชั่วโมง
          const minutes = Math.round((decimalHour - hours) * 60);

          let durationText = "";
          if (hours > 0 && minutes > 0) {
            durationText = `${hours} ชั่วโมง ${minutes} นาที`;
          } else if (hours > 0) {
            durationText = `${hours} ชั่วโมง`;
          } else {
            durationText = `${minutes} นาที`;
          }
          item.durationShow = durationText;
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      // console.log("onOptionsUpdate options:", JSON.stringify(options));

      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "ASC";
      } else {
        sortDesc = "DESC";
      }

      /*
        page,
  limit,
  sortBy,
  sortOrder,
  user_id,
  search,
  searchCharge,
  searchChargeJob,
  datefrom,
  dateto
     */

      try {
        const result = await api.getAllActivityByUserIDPaginationV2(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          localStorage.getItem(server.USER_ID),
          this.search,
          this.searchCharge,
          this.searchChargeJob,
          this.datefrom,
          this.dateto
        );

        // console.log("onOptionsUpdate API result:", JSON.stringify(result));

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.mDataArray2.forEach((item) => {
          var decimalHour = Number(item.duration);
          const hours = Math.floor(decimalHour); // ได้ 3 ชั่วโมง
          const minutes = Math.round((decimalHour - hours) * 60);

          let durationText = "";
          if (hours > 0 && minutes > 0) {
            durationText = `${hours} ชั่วโมง ${minutes} นาที`;
          } else if (hours > 0) {
            durationText = `${hours} ชั่วโมง`;
          } else {
            durationText = `${minutes} นาที`;
          }
          item.durationShow = durationText;
        });

        // console.log(`result.data.data: ${JSON.stringify(result.data.data)}`);
        // console.log(
        //   `result.data.pagination: ${JSON.stringify(result.data.pagination)}`
        // );

        /*
        {
  "currentPage": 1,
  "totalPages": 124,
  "totalRecords": 124,
  "recordsPerPage": 1,
  "hasNextPage": true,
  "hasPreviousPage": false,
  "nextPage": 2,
  "prevPage": null
}
        */
        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      /*
          page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        const result = await api.getAllActivityByUserIDPaginationV2(
          pageNumber,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.USER_ID),
          this.search,
          this.searchCharge,
          this.searchChargeJob,
          this.datefrom,
          this.dateto
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.mDataArray2.forEach((item) => {
          var decimalHour = Number(item.duration);
          const hours = Math.floor(decimalHour); // ได้ 3 ชั่วโมง
          const minutes = Math.round((decimalHour - hours) * 60);

          let durationText = "";
          if (hours > 0 && minutes > 0) {
            durationText = `${hours} ชั่วโมง ${minutes} นาที`;
          } else if (hours > 0) {
            durationText = `${hours} ชั่วโมง`;
          } else {
            durationText = `${minutes} นาที`;
          }
          item.durationShow = durationText;
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        const result = await api.getAllActivityByUserIDPaginationV2(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.USER_ID),
          this.search,
          this.searchCharge,
          this.searchChargeJob,
          this.datefrom,
          this.dateto
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.mDataArray2.forEach((item) => {
          var decimalHour = Number(item.duration);
          const hours = Math.floor(decimalHour); // ได้ 3 ชั่วโมง
          const minutes = Math.round((decimalHour - hours) * 60);

          let durationText = "";
          if (hours > 0 && minutes > 0) {
            durationText = `${hours} ชั่วโมง ${minutes} นาที`;
          } else if (hours > 0) {
            durationText = `${hours} ชั่วโมง`;
          } else {
            durationText = `${minutes} นาที`;
          }
          item.durationShow = durationText;
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    editItem() {},
    changelange: function(newVal, oldVal) {},
    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },
    finddatafromdate() {
      this.searchStu_date = 1;
      this.mDataArray = this.dataAll.filter((item) => {
        if (this.searchCharge == null) {
          if (this.searchChargeJob == null) {
            if (this.datefrom != null && this.dateto != null) {
              if (
                item.checkInDate_S >= this.datefrom &&
                item.checkOutDate_S <= this.dateto
              ) {
                return item;
              }
            }
            if (this.datefrom == null && this.dateto == null) {
              return item;
            }
          } else {
            if (this.datefrom != null && this.dateto != null) {
              if (
                item.checkInDate_S >= this.datefrom &&
                item.checkOutDate_S <= this.dateto &&
                item.job_name == this.searchChargeJob
              ) {
                return item;
              }
            }
            if (this.datefrom == null && this.dateto == null) {
              if (item.job_name == this.searchChargeJob) {
                return item;
              }
            }
          }
        } else {
          if (this.searchChargeJob == null) {
            if (this.datefrom != null && this.dateto != null) {
              if (
                item.checkInDate_S >= this.datefrom &&
                item.checkOutDate_S <= this.dateto &&
                item.chargeType == this.searchCharge
              ) {
                return item;
              }
            }
            if (this.datefrom == null && this.dateto == null) {
              if (item.chargeType == this.searchCharge) {
                return item;
              }
            }
          } else {
            if (this.datefrom != null && this.dateto != null) {
              if (
                item.checkInDate_S >= this.datefrom &&
                item.checkOutDate_S <= this.dateto &&
                item.chargeType == this.searchCharge &&
                item.job_name == this.searchChargeJob
              ) {
                return item;
              }
            }
            if (this.datefrom == null && this.dateto == null) {
              if (
                item.chargeType == this.searchCharge &&
                item.job_name == this.searchChargeJob
              ) {
                return item;
              }
            }
          }
        }
      });
    },

    findChaege() {
      // เริ่มจากข้อมูลทั้งหมด
      let filteredData = [...this.dataAll2];

      // กรองด้วย search text
      if (this.search && this.search.trim() !== "") {
        const searchLower = this.search.toLowerCase();

        filteredData = filteredData.filter((item) => {
          return (
            (item.job_name || "").toLowerCase().includes(searchLower) ||
            (item.customer_name || "").toLowerCase().includes(searchLower) ||
            (item.checkInDate_show || "").toLowerCase().includes(searchLower) ||
            (item.checkOutDate_show || "")
              .toLowerCase()
              .includes(searchLower) ||
            (item.durationShow || "").toLowerCase().includes(searchLower) ||
            (item.chargeType || "").toLowerCase().includes(searchLower) ||
            (item.prospect || "").toLowerCase().includes(searchLower) ||
            (item.detail || "").toLowerCase().includes(searchLower)
          );
        });
      }

      // กรองด้วย Charge Type
      if (this.searchCharge) {
        filteredData = filteredData.filter(
          (item) => item.chargeType === this.searchCharge
        );
      }

      // กรองด้วย Job Title
      if (this.searchChargeJob) {
        filteredData = filteredData.filter(
          (item) => item.job_name === this.searchChargeJob
        );
      }

      // กรองด้วยช่วงวันที่
      if (this.datefrom && this.dateto) {
        filteredData = filteredData.filter(
          (item) =>
            item.checkInDate_S >= this.datefrom &&
            item.checkOutDate_S <= this.dateto
        );
      }

      // กรองด้วย Employee (ถ้ามี)
      if (this.searchEmp && this.searchEmp.length > 0) {
        filteredData = filteredData.filter((item) =>
          this.searchEmp.includes(Number(item.userId))
        );
      }

      // อัปเดตข้อมูลที่แสดงในตาราง
      this.mDataArray2 = filteredData;
    },
    async loadAuthorize() {
      const res_get = await api.getSettingGroupMenu();
      // console.log("res loadAuthorize : ", JSON.stringify(res_get));
      this.authorize = res_get.data;
    },

    async loaddata() {
      const res_joblist = await api.getAllJobtitleByCompany(
        localStorage.getItem(server.COMPANYID)
      );
      this.jobTitle_list = res_joblist.data;

      const resData = await api.getAllActivityByUserID(
        localStorage.getItem(server.USER_ID)
      );
      this.dataAll = resData.data;
      this.mDataArray = resData.data;
      this.mDataArray.forEach((item) => {
        var decimalHour = Number(item.duration);
        const hours = Math.floor(decimalHour); // ได้ 3 ชั่วโมง
        const minutes = Math.round((decimalHour - hours) * 60);

        let durationText = "";
        if (hours > 0 && minutes > 0) {
          durationText = `${hours} ชั่วโมง ${minutes} นาที`;
        } else if (hours > 0) {
          durationText = `${hours} ชั่วโมง`;
        } else {
          durationText = `${minutes} นาที`;
        }
        item.durationShow = durationText;
      });
      this.$hideLoader();
    },

    openeditItem(id) {
      this.$router.push(`/edit-activity/${id}`);
    },

    deleteItem(id) {
      this.delete_id = id;
      this.dialogDeleteActivity = true;
    },

    async deleteItemConfirm() {
      this.$showLoader();

      const delete_activity = await api.deleteActivity(this.delete_id);

      if (delete_activity.status == 200 || delete_activity.status == 201) {
        this.dialogDeleteActivity = false;
        await this.loadAuthorize();
        await this.loaddata();
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Successfully  Deleted",
          "The activity has been successfully deleted.",
          "text-h5 green--text text-center"
        );
        return;
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ลบข้อมูล",
          "ไม่สามารถลบได้",
          "text-h5 red--text text-center"
        );
      }
    },

    closeDelete() {
      this.delete_id = 0;
      this.dialogDeleteActivity = false;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
